import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["paste_btn"]

  connect() {
    // Controller connected
  }

  preventIfDisabled(event) {
    // Si el botón está deshabilitado, prevenir el click
    if (event.target.classList.contains('disabled')) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }

  copy(event) {
    event.preventDefault();
    const copyIndex = event.target.dataset.index;

    // Habilitar todos los botones de pegar y actualizar sus URLs
    this.paste_btnTargets.forEach((paste_btn) => {
      const pasteIndex = paste_btn.dataset.index;
      const baseUrl = paste_btn.dataset.baseUrl;

      // Construir la URL con los parámetros
      const separator = baseUrl.includes('?') ? '&' : '?';
      paste_btn.href = `${baseUrl}${separator}copy=${copyIndex}&paste=${pasteIndex}`;

      // Habilitar el botón
      paste_btn.classList.remove('disabled');
      paste_btn.style.pointerEvents = 'auto';
      paste_btn.style.opacity = '1';
    })
  }

  copyToAll(event) {
    event.preventDefault();
    const copyIndex = event.target.dataset.index;
    const url = event.target.href;

    // Update the URL to include the copy parameter
    const separator = url.includes('?') ? '&' : '?';
    event.target.href = `${url}${separator}copy=${copyIndex}`;
  }

  submit(event) {
    // Mostrar indicador de carga
    const form = event.target.closest('form')
    const submitButton = form.querySelector('input[type="submit"]')
    const originalValue = submitButton ? submitButton.value : ''

    if (submitButton) {
      submitButton.value = 'Guardando...'
      submitButton.disabled = true
    }

    // Enviar el formulario
    Rails.fire(form, 'submit')

    // Restaurar el botón después de un tiempo
    setTimeout(() => {
      if (submitButton) {
        submitButton.value = originalValue
        submitButton.disabled = false
      }
    }, 2000)
  }

  confirmReplicate(event) {
    event.preventDefault()
    const confirmed = confirm('¿Está seguro que desea replicar las calorías y colaciones de este día al resto de la semana? Esta acción sobrescribirá los datos de los demás días.')
    
    if (confirmed) {
      const form = event.target.closest('form')
      if (form) {
        form.submit()
      }
    }
  }
}
